// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"f93c8b41","160":"22ecc9e4","208":"2ab3b8fb","293":"8233d223","516":"4a9c50b0","519":"14d70b67","840":"7bd88c24","917":"d74b5e98","946":"52b457ab"}[chunkId] + ".chunk.js";
};